import React from 'react'

type Props = {
    className?  : string,

    viewConfig  : any
}

export default function AddView_ViewHeader(props: Props) {

    const classes = Classes("flex-row-left-top", props.className)

    return (
        <div className={classes}>
            <div className={Classes("flex-no-shrink w-45 m-r-10", props.viewConfig.iconSvg)}></div>

            <div className="flex-column-left-top">
                <div className="ui5-title-app-name m-t-3">{props.viewConfig.name}</div>
                <div className="description ui5-txt-less-important-small m-t-5 lh-14em">{props.viewConfig.description}</div>
            </div>
        </div>
    )

}
